import { fromJS } from 'immutable';

import {
  GET_PIN_FOR_AUTHORIZE,
  GET_PIN_FOR_AUTHORIZE_LOADED,
  GET_CODE_OF_AUTHORIZE,
  GET_CODE_OF_AUTHORIZE_LOADED,
  GET_CODE_OF_AUTHORIZE_ERROR,
  SET_FORM_PHONE_NUMBER_REQUEST,
  SET_FORM_PIN_NUMBER_REQUEST,
  VALID_INPUT_PHONE,
  VALID_INPUT_PIN,
  EDIT_PHONE_NUMBER,
  SHOW_MESSAGE_WITHOUT_SUBSCRIPTION,
  SET_FORM_REGISTER_REQUEST,
  REGISTER_PHONE,
  REGISTER_PHONE_LOADED,
  REGISTER_PHONE_ERROR,
  BOOTSTRAP_DATA,
  LOADING_ON,
  LOADING_OFF,
  SUBSCRIPTION_PLAN
} from './constants';

const initialState = fromJS({
  loading: null,
  phoneNumber: null,
  pinNumber: null,
  pinForAuthorizeData: null,
  pinForAuthorizeLoaded: null,
  pinForAuthorizeError: null,
  formRequestConfig: null,
  pinForAuthorize: null,
  subscriptionUri: null,
  registerForm: false,
  subscriptionPlan: ''
});

const loginPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_DATA:
      return state
        .set('initialDataConfig', action.data);
    case VALID_INPUT_PHONE:
      return state
        .set('formRequestConfig', { ...state.get('formRequestConfig'), btntext: 'CONTINUAR' })
        .set('phoneNumber', action.phoneNumber)
        .set('pinForAuthorizeLoaded', null)
        .set('pinForAuthorizeError', null);
    case VALID_INPUT_PIN:
      return state
        .set('pinNumber', action.pinNumber);
    case EDIT_PHONE_NUMBER:
      return state
        .set('phoneNumber', action.phoneNumber)
        .set('pinNumber', null)
        .set('pinForAuthorizeLoaded', false);
    case SET_FORM_PHONE_NUMBER_REQUEST:
      return state
        .set('formRequestConfig', action.props)
        .set('loading', action.props.isLoading)
        .set('registerForm', false);
    case SET_FORM_REGISTER_REQUEST:
      return state
        .set('formRequestConfig', action.props)
        .set('loading', action.props.isLoading)
        .set('registerForm', true);
    case SET_FORM_PIN_NUMBER_REQUEST:
      return state
        .set('formRequestConfig', action.props)
        .set('loading', 0)
        .set('registerForm', false);
    case GET_PIN_FOR_AUTHORIZE:
      return state
        .set('loading', 1)
        .set('pinNumber', null)
        .set('pinForAuthorizeLoaded', null)
        .set('pinForAuthorizeError', null);
    case GET_PIN_FOR_AUTHORIZE_LOADED:
      return state
        .set('pinForAuthorizeData', action.data)
        .set('pinForAuthorizeLoaded', true)
        .set('pinForAuthorizeError', null)
        .set('loading', 0);
    case REGISTER_PHONE:
      return state
        .set('loading', 1)
        .set('pinNumber', null);
    case REGISTER_PHONE_LOADED:
      return state
        .set('pinForAuthorizeData', action.data)
        .set('loading', 0);
    case REGISTER_PHONE_ERROR:
      return state
        .set('pinForAuthorizeError', action.error)
        .set('loading', 0);
    case GET_CODE_OF_AUTHORIZE:
      return state
        .set('pinForAuthorizeError', null)
        .set('loading', 1);
    case GET_CODE_OF_AUTHORIZE_LOADED:
      return state
        .set('loading', 0);
    case GET_CODE_OF_AUTHORIZE_ERROR:
      return state
        .set('pinForAuthorizeError', action.error)
        .set('loading', 0);
    case SHOW_MESSAGE_WITHOUT_SUBSCRIPTION:
      return state
        .set('subscriptionUri', action.subscriptionUri);
    case LOADING_ON:
      return state
        .set('loading', 1);
    case LOADING_OFF:
      return state
        .set('loading', 0);
    case SUBSCRIPTION_PLAN:
      return state
        .set('subscriptionPlan', action.subscriptionPlan)
    default:
      return state;
  }
};

export default loginPageReducer;
